import Api from './Api_Usuario';

async function Api_UsuarioLogin(cuit_psw) { 
    let ret = false
    const body = cuit_psw
    const token = null;
    console.log('body_Api_UsuarioLogin: ' + body)
    try {
        const response = await Api.post(`Usuario/login`, body, {
            headers: {
                'Content-Type': 'application/json',
                 //Authorization: `Bearer ${token}`,
            }          
        })
        console.log('Api_UsuarioLogin: ',response.data)           
        return response
    }
    catch (error) {
        console.log('[error Api_UsuarioLogin]: ' + error);
    } 
    return ret
}

export default Api_UsuarioLogin;